export const forceClearTranslationCookies = () => {
  const hostname = window.location.hostname;
  const expiry = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
  
  const domains = [
    '',
    hostname,
    `.${hostname}`,
  ];
  
  if (hostname.includes('.')) {
    const parts = hostname.split('.');
    for (let i = 1; i < parts.length; i++) {
      const domain = parts.slice(i).join('.');
      domains.push(domain, `.${domain}`);
    }
  }
  
  ['googtrans', 'googtrans-original'].forEach(name => {
    domains.forEach(domain => {
      if (domain) {
        document.cookie = `${name}=; ${expiry}; path=/; domain=${domain}`;
        document.cookie = `${name}=; ${expiry}; path=/; domain=${domain}; SameSite=Lax`;
        document.cookie = `${name}=; ${expiry}; path=/; domain=${domain}; SameSite=None; Secure`;
      } else {
        document.cookie = `${name}=; ${expiry}; path=/`;
      }
    });
  });
};

// Destroy Google Translate completely
export const destroyGoogleTranslate = () => {
  console.log('[Destroy] Removing Google Translate...');
  
  // Remove all Google Translate elements
  document.querySelectorAll('.skiptranslate, iframe.skiptranslate, .goog-te-banner-frame, #goog-gt-tt, .goog-te-spinner-pos').forEach(el => {
    el.remove();
  });
  
  // Reset body styles
  if (document.body) {
    document.body.style.top = '';
    document.body.classList.remove('translated-ltr', 'translated-rtl');
  }
  
  // Clear container
  const container = document.getElementById('google_translate_element');
  if (container) container.innerHTML = '';
  
  // Remove script
  const script = document.getElementById('google-translate-script');
  if (script) script.remove();
  
  // Clear globals
  delete window.google;
  delete window.googleTranslateElementInit;
  window.googleTranslateLoaded = false;
};

// Get current language from cookie
export const getInitialLanguageFromCookie = () => {
  try {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'googtrans' && value) {
        const match = value.match(/\/(?:en|auto)\/([^\/]+)/);
        if (match && match[1]) {
          return match[1];
        }
      }
    }
    
    return localStorage.getItem('selectedLang') || 'en';
  } catch (e) {
    return 'en';
  }
};